
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Añádelo a tu pantalla de inicio para una experiencia amplia y acceso fácil.`,
's224cbcec014ef6b5': `Presionar Compartir en la barra de direcciones`,
's37a9e8aec5713460': `Más`,
's386eca8362ff6155': `Presiona Más si no hay icono de Compartir`,
's4e1e10a6ca408245': `Toca "Añadir a pantalla de inicio"`,
's6196153c4b0c1ea0': `Instalar`,
's633502f7cff4f847': `Abre el menú de tu navegador`,
's681e399d63311fba': `Mostrar galería`,
's7f0591f08e318eda': `Presiona Más en el menú de Compartir`,
's8114bd55cae5a22b': `Presionar Añadir al Dock`,
's922329d6f6213590': `Añadir al Dock`,
's9af56bf005b49c74': `Desplázate hacia abajo hasta "Añadir a pantalla de inicio"`,
'sa5ef80b4bb9b39f8': `Menos`,
'sba52286c21552a4e': `Instálalo en tu dispositivo para una experiencia amplia y acceso fácil.`,
'sc16e00a7a8b2fde2': `Atrás`,
'scdaf4bbff76674c8': `Añadir a pantalla de inicio`,
'se0e473adfda8066c': `Abre en tu navegador principal`,
'se740f75b95a51807': `Añádelo a tu Dock para una experiencia amplia y acceso fácil.`,
'sfea652f6580ff086': `Este sitio tiene funcionalidad de aplicación.`,
    };
  